import React, {Component} from "react";
import $ from "jquery";
import datepicker from "js-datepicker";
import {ASBESTOS} from '../Constants';
import {Badge} from "reactstrap";

export default class Asbestos  extends Component{

    constructor(props) {

        super(props);

        this.state = ASBESTOS;
    }

    componentDidMount(){
        const {position} = this.props;
        this.initDatePicker(position);
        let data = this.props.data;
        let keys = Object.keys(data);

        if(data){
            for (let key in keys){
                this.setState({[keys[key]]: data[keys[key]]});
            }
        }
    }

    onChange = (event) => {
        this.onValueChange(event.target.name, event.target.value)
    };

    onValueChange= (name, value) => {
        this.setState({
            [name]: value
        });
        this.props.update(this.props.type,  this.props.position, name, value);
    };

    initDatePicker(position){

        let that = this;

        if($(document).find(`.datepicker_${position}`).length > 0){
            datepicker(document.querySelector(`.datepicker_${position}`), {
                position: 'c',
                startDate: new Date(),
                startDay: 1,
                dateSelected: new Date(),
                minDate: new Date(2016, 5, 1),
                maxDate: new Date(2099, 0, 1),
                noWeekends: false,
                customMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                customDays: ['S', 'M', 'T', 'W', 'Th', 'F', 'S'],
                overlayPlaceholder: 'Enter a 4-digit year',
                overlayButton: 'Select!',
                disableMobile: false,

                formatter: (input, date, instance) => {
                    that.onValueChange($(input).attr('name'), date.toDateString());
                    input.value = date.toDateString()
                },
            });
        }


    };


    render(){

        const {
            rates,
            removeActivity,
            type,
            position
        } = this.props;


        const {
            severity,
            likelihood,
            location,
            damage_potential,
            accessible,
            material_type,
            date_identified,
            condition,
            friability
        } = this.state;

        return(
            <div className="template-holder" style={{backgroundColor: "#ccc",padding: "10px",borderRadius: "4px",marginBottom: "15px",position: "relative"}}>
                {
                    position !== 0?
                        <Badge
                            onClick={() => removeActivity(type, position)}
                            color="danger" style={{position: "absolute", right: "15px", cursor: "pointer", zIndex:1000}}>X</Badge>: null
                }
                <div className="form-group" style={{position: 'relative'}}>
                    <label htmlFor="date_identified" className="control-label required">
                        Date Identified</label>
                    <input
                        onChange={this.onChange}
                        className={`form-control datepicker_${position}`}
                        autoComplete="off"
                        required="required"
                        name="date_identified"
                        type="text"
                        id={`date_identified_${position}`}/>
                </div>
                <div className="form-group">
                    <label
                        htmlFor="location"
                        className="control-label required">
                        Location
                    </label>
                    <textarea onChange={this.onChange} className="form-control required" name="location" id="location" value={location}/>
                </div>
                <div className="form-group">
                    <label
                        htmlFor="material_type"
                        className="control-label required">
                        Type of material
                    </label>
                    <textarea onChange={this.onChange}
                              className="form-control required"
                              name="material_type"
                              id="material_type" value={material_type}/>
                </div>

                <div className="form-group" style={{width: '100%'}}>
                    <label
                        htmlFor="friability"
                        className="control-label required">
                        Friability
                    </label>
                    <select
                        value={friability}
                        onChange={this.onChange}
                        className="selectpicker form-control"
                        required="required"
                        id="friability"
                        name="friability">
                        <option value="">Select an option</option>
                        <option value="Yes">Friable</option>
                        <option value="No">Not Friable</option>
                    </select>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="condition"
                        className="control-label required">
                        Condition
                    </label>
                    <textarea onChange={this.onChange}
                              className="form-control required"
                              name="condition"
                              id="condition" value={condition}/>
                </div>

                <div className="form-group" style={{width: '100%'}}>
                    <label
                        htmlFor="accessible"
                        className="control-label required">
                        Accessible
                    </label>
                    <select
                        value={accessible}
                        onChange={this.onChange}
                        className="selectpicker form-control"
                        required="required"
                        id="accessible"
                        name="accessible">
                        <option value="">Select an option</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="damage_potential"
                        className="control-label required">
                        Potential to be damaged & how
                    </label>
                    <textarea onChange={this.onChange}
                              className="form-control required"
                              name="damage_potential"
                              id="damage_potential" value={damage_potential}/>
                </div>

                <h6>Risk Rating: </h6>

                <div style={{display: 'flex', flexDirection: 'columns'}}>
                    <div className="form-group" style={{width: '100%'}}>
                        <label
                            htmlFor="severity"
                            className="control-label required">
                            Severity
                        </label>
                        <select
                            value={severity}
                            onChange={this.onChange}
                            className="selectpicker form-control"
                            required="required"
                            id="severity"
                            name="severity">
                            <option value="">Select an option</option>
                            {
                                Object.keys(rates).map(key => <option key={key} value={key}>{rates[key]}</option>)
                            }
                        </select>

                    </div>
                    <div className="form-group" style={{width: '100%'}}>
                        <label
                            htmlFor="likelihood"
                            className="control-label required">
                            Likelihood
                        </label>
                        <select
                            value={likelihood}
                            onChange={this.onChange}
                            className="selectpicker form-control"
                            required="required"
                            id="likelihood"
                            name="likelihood">
                            <option value="">Select an option</option>
                            {
                                Object.keys(rates).map(key => <option key={key} value={key}>{rates[key]}</option>)
                            }
                        </select>

                    </div>
                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/screens/risks/templates/Asbestos.js